import React, { useRef, useState } from 'react';
import cx from 'classnames';

import './NavigationOverlay.scss';
import { useMessageBusSubscribe } from '../messagebus';

export const NavigationOverlay = () => {

  const [fadeOut, setFadeout] = useState(false);
  const fadeoutTimeout = useRef();

  useMessageBusSubscribe('wh.common.event.ui.header.product.requested', () => {
    setFadeout(true);
    if (fadeoutTimeout.current) {
      clearTimeout(fadeoutTimeout.current);
    }
    fadeoutTimeout.current = setTimeout(() => {
      setFadeout(false);
    }, 4000);
  });

  return <div className={cx('navigation-overlay', {
    fadeOut
  })}></div>
}
